import { QueryClient } from 'react-query';

import { RequestContext } from '@common/api-request';

import { TraitType } from '../constants/trait_type';
import { getMaximumBenefit } from '../graphql/maximum-benefit.2';
import { GetMaximumBenefitVariables, PaymentProductType } from '../graphql/maximum-benefit_types.2';
import {
  GetPdpBaseInfo_catalog_product_base_info_product_product_price,
  GetPdpBaseInfo_catalog_product_base_info_product_trait_list,
} from '../graphql/pdp-base-info_types.2';
import { queryOptions } from '../lib/queryHelpers';

interface QueryParams {
  params: GetMaximumBenefitVariables;
  enabled?: boolean;
  context?: RequestContext;
}

const QUERY_KEY = 'getMaximumBenefit';

interface GetMaximumBenefitParamProps {
  productId: string;
  productPrice?: GetPdpBaseInfo_catalog_product_base_info_product_product_price;
  shopId: string;
  traitList: GetPdpBaseInfo_catalog_product_base_info_product_trait_list[] | null;
}
export function getMaximumBenefitParam({ productId, productPrice, shopId, traitList }: GetMaximumBenefitParamProps) {
  const promotionDiscountPrice = productPrice?.product_promotion_discount_info?.discount_price ?? 0;
  const sellerDiscountPrice = productPrice?.store_discount_info?.discount_price ?? 0;
  const discountPrice = Math.min(...[promotionDiscountPrice, sellerDiscountPrice].filter(Boolean));
  const maxPrice = productPrice?.max_price_info?.price ?? 0;
  const isOverseasPurchaseAgency = traitList?.some((trait) => trait.type === TraitType.OVERSEAS_PURCHASE_AGENCY);

  return {
    params: {
      input: {
        catalog_product_id: productId,
        discount_price: Number.isFinite(discountPrice) ? discountPrice : maxPrice,
      },
      catalog_product_id: productId,
      payment_event_target_list: [{ shop_id: shopId }],
      product_type_list: isOverseasPurchaseAgency ? [PaymentProductType.OVERSEAS_PURCHASE_AGENCY] : null,
    },
    enabled: Boolean(shopId),
  };
}

export async function requestMaximumBenefit({ params, context }: QueryParams) {
  try {
    const { data } = await getMaximumBenefit(params, { context, show_alert: false });
    return {
      ...data,
    };
  } catch (e) {
    console.error(e);
  }
}

export function maximumBenefitQueryOption({ params, enabled, context }: QueryParams) {
  return {
    queryKey: [QUERY_KEY],
    queryFn: () => requestMaximumBenefit({ params, context }),
    ...queryOptions,
    enabled,
  };
}

export function prefetchMaximumBenefit(queryClient: QueryClient, param: QueryParams) {
  return queryClient.prefetchQuery(QUERY_KEY, () => {
    return requestMaximumBenefit(param);
  });
}
